import { render, staticRenderFns } from "./TabPricesSinRecinto.vue?vue&type=template&id=0f9e057d"
import script from "./TabPricesSinRecinto.vue?vue&type=script&lang=js"
export * from "./TabPricesSinRecinto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports